import { RelationDetailsRoute } from '@domains/subscription/priv/Relations/factories/RelationsListFactory'
import { createCustomTheme } from '@domains/subscription/theme'
import { Container, Stack, ThemeProvider } from '@mui/material'
import { DefaultConfigDetailsPage } from 'pages/DefaultConfigDetails/DefaultConfigDetailsPage'
import { SubscriptionPage } from 'pages/Subscription/SubscriptionPage'
import { TemplateDetailsPage } from 'pages/TemplateDetails/TemplateDetailsPage'
import { Outlet, Route } from 'react-router-dom'
import type { RouteComponentProps } from 'routes/protectedRoutes'

const LayoutWithTheme = ({ heading }: RouteComponentProps) => {
  return (
    <Stack
      sx={{
        overflow: 'hidden',
        height: '100vh',
        bgcolor: 'background.default',
      }}
    >
      {heading}
      <ThemeProvider theme={createCustomTheme()}>
        <Stack
          sx={{
            flex: 1,
            paddingTop: 4,
            flexGrow: 1,
            bgcolor: 'background.default',
            overflow: 'hidden',
            minHeight: 0,
          }}
        >
          <Container sx={{ display: 'flex', flex: 1, overflow: 'hidden', minHeight: 0 }} maxWidth="md">
            <Outlet />
          </Container>
        </Stack>
      </ThemeProvider>
    </Stack>
  )
}

interface RouterParams {
  templateId: string
  tab: string
  id: string
}

export const createRoute = {
  subscription: () => '/subscription',
  templateDetails: ({ templateId }: Pick<RouterParams, 'templateId'>) => `/subscription/${templateId}`,
  templateDetailsTab: ({ templateId, tab }: Pick<RouterParams, 'templateId' | 'tab'>) => `/subscription/${templateId}/${tab}`,
  configDetails: ({ configId }: { configId: string }) => `/subscription/config/${configId}`,
  templateDetailsTabWithId: ({ templateId, tab, id }: RouterParams) => `/subscription/${templateId}/${tab}/${id}`,
  relations: () => '/subscription/relations',
}

export const SubscriptionRouter = ({ heading }: RouteComponentProps) => (
  <Route path="" element={<LayoutWithTheme heading={heading} />}>
    <Route path="/subscription" element={<SubscriptionPage />} />
    <Route path="/subscription/relations" element={<SubscriptionPage />} />
    <Route path="/subscription/relations/:relationId" element={<RelationDetailsRoute />} />
    <Route path="/subscription/default-configs" element={<SubscriptionPage />} />
    <Route path="/subscription/bulk-migration" element={<SubscriptionPage />} />
    <Route path="/subscription/:templateId">
      <Route path=":tab" element={<TemplateDetailsPage />}>
        <Route path=":id" element={<TemplateDetailsPage />} />
      </Route>
    </Route>
    <Route path="/subscription/config/:configId" element={<DefaultConfigDetailsPage />} />
  </Route>
)
